import {
  Space,
  Dropdown,
  message
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
} from "react";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import { CustomTable, CustomTableExtend } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const initTableHead = {
    addressCityStateZip: null,
    loanNumber: null,
    propType: null,
    loanRatio: null,
    currentLoan: null,
    originalLoan: null,
    allocation: null,
    paidOffDate: null,
    soldDate: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn, pageSize: 100})
  }

  const initColumns = [
    {
      title: 'Prop#',
      dataIndex: "prop",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'prop')
    },
    {
      title: 'Address City State Zip',
      dataIndex: "addressCityStateZip",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      width: 200,
      onChange: e => tableFilterFn(e, 'addressCityStateZip')
    },
    {
      title: 'Prop Type',
      dataIndex: "propType",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'propType')
    },
    {
      title: 'Units',
      dataIndex: "units",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
    },
    {
      title: "Lender",
      dataIndex: "lender",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "lender"),
    },
    {
      title: "Interest Rate",
      dataIndex: "interestRate",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      isPercent: true,
      onChange: (e) => tableFilterFn(e, "interestRate"),
    },
    {
      title: 'Loan Number',
      dataIndex: "loanNumber",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'loanNumber')
    },
    // {
    //   title: 'Ratio',
    //   dataIndex: "loanRatio",
    //   titleType: 'Input',
    //   isSorter: true,
    //   isPercent: true,
    //   sortterMultiple: 3,
    //   onChange: e => tableFilterFn(e, 'loanRatio')
    // },
    // {
    //   title: "Current Loan",
    //   dataIndex: "currentLoan",
    //   titleType: "Input",
    //   width: 100,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   isAmountFlag: true,
    //   onChange: (e) => tableFilterFn(e, "currentLoan"),
    // },
    {
      title: 'Liability GL',
      dataIndex: "liabilityGlAcct",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'liabilityGlAcct')
    },
    {
      title: 'Expense GL',
      dataIndex: "expenseGlAcct",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'expenseGlAcct')
    },
    {
      title: "Loan Balance",
      dataIndex: "loanBalance",
      titleType: "",
      isAmountFlag: true,
    },
    // {
    //   title: 'Monthly',
    //   dataIndex: "monthlyFee",
    //   titleType: '',
    //   isSorter: true,
    //   sortterMultiple: 3,
    // },

    // {
    //   title: "Original Loan",
    //   dataIndex: "originalLoan",
    //   titleType: "Input",
    //   width: 100,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   isAmountFlag: true,
    //   onChange: (e) => tableFilterFn(e, "originalLoan"),
    // },
    // {
    //   title: "Allocation",
    //   dataIndex: "allocation",
    //   titleType: "Input",
    //   width: 100,
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   isAmountFlag: true,
    //   onChange: (e) => tableFilterFn(e, "allocation"),
    // },
    // {
    //   title: 'Sold Date',
    //   dataIndex: "soldDate",
    //   titleType: 'DatePicker',
    //   isSorter: false,
    //   format: 'MM/DD/YYYY',
    //   onChange: (e) => tableFilterFn(e, 'soldDate', 'DatePicker'),
    // },
  ]

  const initColumns1 = [
    {
      title: 'Entity',
      dataIndex: "entityStrList",
      titleType: '',
      isSorter: true,
      width: 120,
      sortterMultiple: 3,
      render: (text) => {
        return (
          <>
            {(text || [])?.map(item => (
               <div>
                { item }
              </div>
            ))}
          </>
        )
      }
    },
    {
      title: 'Paid Off Date',
      dataIndex: "paidOffDate",
      titleType: 'DatePicker',
      isSorter: false,
      format: 'MM/DD/YYYY',
      onChange: (e) => tableFilterFn(e, 'paidOffDate', 'DatePicker'),
    },
  ]

  const [columns, setColumns] = useState([...initColumns, ...initColumns1]);
  const [month6Columns, setMonth6Columns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.post(api.getMortgageSubListByProp, params);
    if(!response) return
    if(response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setPagination({
      current: 1,
      pageSize: 100,
      total: 0,
    })
    setTableList([])
    setTableHead(initTableHead);
    setColumns([...initColumns, ...month6Columns, ...initColumns1]);
  }

  const month6ColumnsFn = async () => {
    const response = await http.get(api.mortgageTitle);
    if(response?.code === "1"){
      const month6Columns = (response?.data || [])?.map((month) => ({
        title: month,
        dataIndex: month,
        key: month,
        width: 100,
        onCell: () => ({className: 'cellAmount'}),
        render: (text, record) => {
          const result = record?.map?.[month] || null;
          return result?.repayment ? (<span
            style={{
              color: result?.colorStr || "#1890ff",
            }}
          >
            {commonFn.amountToDollarFn(result?.repayment)}
          </span>) : null
        },
      }));
      setMonth6Columns(month6Columns)
    }
  };

  useEffect(() => {
    month6ColumnsFn();
  }, [])

  useEffect(() => {
    if(month6Columns?.length){
    setColumns([...initColumns, ...month6Columns, ...initColumns1]);
    }
  }, [month6Columns])

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 100)
  }, [refreshKey])

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
      >
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={false}
        rowKey="id"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="340px"
      />
    </div>
  );
});
export default MainTable;